import { CalendarRange } from 'lucide-vue-next'
import type { App } from 'vue'
import { registerComponents } from './components'

export { type CalendarDay, calendarWeek, zonedDayKey } from './model/week'

export const createCalendar = () => ({
  install: (app: App) => {
    registerComponents(app)

    app.getRouter().addRoute('organization', {
      path: 'calendar',
      name: 'calendar',
      meta: {
        head: { titleKey: 'calendar.title' },
        nav: { icon: CalendarRange, order: 1 },
        crumbs: [{ labelKey: 'nav.workspace', to: { name: 'dashboard' } }, { labelKey: 'calendar.title' }]
      },
      components: {
        default: () => import('./pages/CalendarPage.vue'),
        header: () => import('./components/CalendarHeader.vue')
      }
    })
  }
})
